import React, { useState } from "react";
import { Image } from "./image";
import { Modal } from "./modal";

export const Gallery = ({ data = [] }) => {
  const [activeIndex, setActiveIndex] = useState(null);
  const activeItem = activeIndex !== null ? data[activeIndex] : null;

  return (
    <div id="portfolio" className="text-center">
      <div className="container" style={{ display: "flex", flexDirection: "column", alignItems: "center"}}>
        <div className="section-title">
          <h2>Outras Especialidades</h2>
          <p>
            Conheça outras áreas clínicas complementares, com profissionais
            qualificados e abordagens integradas para o seu bem-estar.
          </p>
        </div>

        <div className="row" style={{ width: "80%", maxWidth: "1100px" }}>
          <div className="portfolio-items">
            {data.length
              ? data.map((d, i) => (
                  <div
                    key={`${d.title}-${i}`}
                    className="col-sm-6 col-md-4 col-lg-4"
                  >
                    <Image
                      title={d.title}
                      smallImage={d.smallImage}
                      onClick={() => setActiveIndex(i)}
                    />
                  </div>
                ))
              : "Loading..."}
          </div>
        </div>
      </div>

      <Modal
        isOpen={activeIndex !== null}
        onClose={() => setActiveIndex(null)}
        item={activeItem}
      />
    </div>
  );
};
